<div *ngIf="!previewFlow" orientation>
    <div id="flow" class="flow content-block-height icon-block-changes" *ngIf="flowData" [ngClass]="{'flow-no-margin-top':progressBarInfo && progressBarInfo.show}">
        <div class="col-12 p-0">
            <div class="row m-0 p-0">
                <!-- Old Back and Next buttons removed regarding TCCP-1733 -->
                <!--  <div [ngStyle]="{'visibility':isPreview ? 'hidden':'visible'}" class="col-1 p-0 arrows" *ngIf="flowData.issueId && this.storageService.getFeatureType() !== 'internal'">
                    <a class="navigation-arrows back-arrow" (click)="getFlow('','back')" [ngStyle]="{'visibility':isPreview ? 'hidden':'visible'}"
                        *ngIf="flowData.issueId">
                        <img alt="Back" class="icon" [src]="backArrowURL">

                        <div [hidden]="windowWidth > 1023" class="navigation-arrow-text back-text" (click)="getFlow('','back')" [ngStyle]="{'visibility':isPreview ? 'hidden':'visible'}"
                            *ngIf="flowData.issueId">Back</div>
                    </a>
                    <div [hidden]="windowWidth < 1024" class="navigation-arrow-text back-text" (click)="getFlow('','back')" [ngStyle]="{'visibility':isPreview ? 'hidden':'visible'}"
                        *ngIf="flowData.issueId">Back</div>
                </div> -->

                <!-- Removed ngClss regarding TCCP-1733  -->
                <!-- [ngClass]="{'col-10' : this.storageService.getFeatureType() !== 'internal','col-12' : this.storageService.getFeatureType() === 'internal','step-content-internal' : this.storageService.getFeatureType() === 'internal'}" -->
                <div class="p-0 step-content col-12 step-content-internal">
                    <div *ngIf="flowData.informationOrQuestion">
                        <!-- Split screen implementation starts -->
                        <div *ngIf="windowWidth > 1023 && flowData.informationOrQuestion && flowData.hasContentSpliter" class="informationOrquestion">
                            <div class="row col-12 information-container-desktop" [ngStyle]="{'min-height':windowHeight+'px'}">
                                <div class="information-text flow-content-text col-6" style="padding-left: 70px;">
                                    <span class="info-content" #informationtext [innerHTML]="flowData.informationOrQuestion | safeHtml">
                                    </span>

                                    <div class="notes-container-block pt-1" *ngIf="flowData.notes">
                                        <app-notes [notes]="learnmoreLink"></app-notes>
                                    </div>
                                    <div *ngIf="flowData.documents" class="document-link">

                                        <div *ngFor="let document of flowData.documents">
                                            <div *ngFor="let content of contents">
                                                <div class="control-list" *ngIf="flowData.documents.length && flowData.documents.length > 1 && content.contentId==document">
                                                    <ul>
                                                        <li>
                                                            <a [href]=baseUrl+content.document.path target="_blank">{{content.document.fileDisplayName}}</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div class="control-list" *ngIf="flowData.documents.length && flowData.documents.length === 1 && content.contentId==document">
                                                    <a [href]=baseUrl+content.document.path target="_blank">{{content.document.fileDisplayName}}</a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="badge-block badge-split-desktop mt-5" style="display: inline-flex;" *ngIf="((windowWidth > 1200 && flowData.hasContentSpliter) && (flowData.badges && flowData.badges.length > 0))">
                                        <app-badge [badges]="flowData.badges" [splitScreen]="flowData.hasContentSpliter">
                                        </app-badge>
                                    </div>
                                </div>
                                <div class="col-6 controls carousel-container" style="margin-top:0px;justify-content: center;" *ngIf="(((flowData.imagesOrVideos && flowData.imagesOrVideos.length > 0)))">
                                    <app-image-video-carousel *ngIf="flowData.imagesOrVideos" [startIndex]="0" [carouselContainerWidth]="250" [superSlides]="carouselSlides">
                                    </app-image-video-carousel>
                                </div>

                            </div>
                            <div class="row col-12 text-center container-tile-block" [ngClass]="{'responsive-container-tile-block':windowWidth < 768 }"
                                *ngIf="(flowData.controls && flowData.controls.length > 0) || (flowData.phoneCompatibilty)" style="justify-content: center;">
                                <div *ngFor="let control of flowData.controls; let k=index;" class="tile-block">
                                    <button *ngIf="control && control.controlType === 'button' && control?.controlName.toLowerCase() !== 'home'" class="btn control-block"
                                        (click)="isPreview ? '' :  getFlow(control.targetId)" type="button">{{control?.controlName}}</button>

                                    <div *ngIf="control && control.controlType.toLowerCase() === 'tile'" (click)="isPreview ? '' :getFlow(control.targetId)">
                                        <app-tile [control]="control">
                                        </app-tile>
                                    </div>
                                </div>
                                <div class="tile-block">
                                    <button [disabled]="previewFromPublish" *ngIf="(flowData.phoneCompatibilty && flowData.isControlAsButton)" class="btn control-block"
                                        (click)="isPreview ? '' : getCompatible(flowData.phoneCompatibilty.linkUrl)" type="button">{{flowData.phoneCompatibilty.displayName}}</button>
                                    <div *ngIf="flowData.phoneCompatibilty && !flowData.isControlAsButton" (click)="isPreview || previewFromPublish ? '' : getCompatible(flowData.phoneCompatibilty.linkUrl)">
                                        <app-tile [compatible]="flowData.phoneCompatibilty">
                                        </app-tile>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Split screen implementation ends -->
                    </div>
                    <!--Desktop Content Not Split screen implementation starts -->
                    <span *ngIf="flowData.informationOrQuestion" class="informationOrquestion">
                        <div *ngIf="((windowWidth >= 768 && !flowData.hasContentSpliter) ||(windowWidth >= 768 && windowWidth < 1024))" class="information-text flow-content-text col-12">
                            <span class="info-content" #informationtext [innerHTML]="flowData.informationOrQuestion | safeHtml">
                            </span>
                            <div class="notes-container-block pt-1" *ngIf="flowData.notes">
                                <app-notes [notes]="learnmoreLink"></app-notes>
                            </div>
                            <div *ngIf="flowData.documents" class="document-link">
                                <div *ngFor="let document of flowData.documents">
                                    <div *ngFor="let content of contents">
                                        <div class="control-list" *ngIf="flowData.documents && flowData.documents.length > 1 && content.contentId==document">
                                            <ul>
                                                <li>
                                                    <a [href]=baseUrl+content.document.path target="_blank">{{content.document.fileDisplayName}}</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="control-list" *ngIf="flowData.documents.length && flowData.documents.length === 1 && content.contentId==document">
                                            <a [href]=baseUrl+content.document.path target="_blank">{{content.document.fileDisplayName}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>
                    <!--Deshtop Content Not Split screen Images,badges,controls & tiles starts -->
                    <div class="badge-desktop mt-5" style="display: inline-flex;" *ngIf="(((windowWidth >= 768 && !flowData.hasContentSpliter) ||(windowWidth >= 768 && windowWidth < 1024)) && (flowData.badges && flowData.badges.length > 0))">
                        <app-badge [badges]="flowData.badges" [splitScreen]="flowData.hasContentSpliter">
                        </app-badge>
                    </div>
                    <div class="controls carousel-container" *ngIf="(((windowWidth >= 768 && !flowData.hasContentSpliter) ||(windowWidth >= 768 && windowWidth < 1024)) && (flowData.imagesOrVideos && flowData.imagesOrVideos.length > 0))">
                        <app-image-video-carousel *ngIf="flowData.imagesOrVideos && flowData.imagesOrVideos.length > 0" [startIndex]="0" [carouselContainerWidth]="250"
                            [superSlides]="carouselSlides">
                        </app-image-video-carousel>
                    </div>
                    <div class="container-tile-block text-center" [ngClass]="{'responsive-container-tile-block':windowWidth < 768}" *ngIf="(((windowWidth >= 768 && !flowData.hasContentSpliter) ||(windowWidth >= 768 && windowWidth < 1024)) && ((flowData.controls && flowData.controls.length > 0) || flowData.phoneCompatibilty))">
                        <div *ngFor="let control of flowData.controls; let k=index;" class="tile-block">

                            <button *ngIf="control && control.controlType === 'button' && control?.controlName.toLowerCase() !== 'home'" class="btn control-block"
                                (click)="isPreview ? '' : getFlow(control.targetId)" type="button">{{control?.controlName}}</button>

                            <span *ngIf="control && control.controlType.toLowerCase() === 'tile'" (click)="isPreview ? '' : getFlow(control.targetId)">
                                <app-tile [control]="control">
                                </app-tile>
                            </span>
                        </div>
                        <div class="tile-block">
                            <button [disabled]="previewFromPublish" *ngIf="(flowData.phoneCompatibilty && flowData.isControlAsButton)" class="btn control-block"
                                (click)="isPreview ? '' : getCompatible(flowData.phoneCompatibilty.linkUrl)" type="button">{{flowData.phoneCompatibilty.displayName}}</button>
                            <div *ngIf="flowData.phoneCompatibilty && !flowData.isControlAsButton" (click)="isPreview || previewFromPublish ? '' : getCompatible(flowData.phoneCompatibilty.linkUrl)">
                                <app-tile [compatible]="flowData.phoneCompatibilty">
                                </app-tile>
                            </div>
                        </div>
                    </div>
                    <!--Desktop Content implementation ends -->
                    <!-- Mobile devices block starts  -->
                    <div class="row" *ngIf="windowWidth < 768">
                        <div class="col-12">
                            <div class="controls carousel-container" *ngIf="((flowData.imagesOrVideos && flowData.imagesOrVideos.length > 0) )">
                                <app-image-video-carousel *ngIf="flowData.imagesOrVideos" [startIndex]="0" [carouselContainerWidth]="250" [superSlides]="carouselSlides"></app-image-video-carousel>
                            </div>
                        </div>
                    </div>
                    <!-- Commented regarding TCCP-1095 -->
                    <!-- [ngClass]="{'show-more': showMoreText,'information-text-height':!showMoreText}" -->
                    <span *ngIf="flowData.informationOrQuestion" class="informationOrquestion">
                        <div *ngIf="windowWidth < 768" class="information-text flow-content-text col-11 mt-30" [ngClass]="{'col-12': this.storageService.getFeatureType() === 'internal'}"
                            id="showMoreContentBlock">
                            <span id="info-content-text" class="info-content" #informationtext [innerHTML]="flowData.informationOrQuestion | safeHtml">
                            </span>

                            <div class="notes-container-block pt-1" *ngIf="flowData.notes">
                                <app-notes [notes]="learnmoreLink"></app-notes>
                            </div>
                            <div *ngIf="flowData.documents && (flowData.documents.length > 1)" class="document-link">
                                <div *ngFor="let document of flowData.documents">
                                    <div *ngFor="let content of contents">
                                        <div class="control-list" *ngIf="content.contentId==document">
                                            <ul>
                                                <li>
                                                    <a [href]=baseUrl+content.document.path target="_blank">{{content.document.fileDisplayName}}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="flowData.documents && (flowData.documents.length == 1)" class="document-link">
                                <div *ngFor="let document of flowData.documents">
                                    <div *ngFor="let content of contents">
                                        <div class="control-list" *ngIf="content.contentId==document">
                                            <a [href]=baseUrl+content.document.path target="_blank">{{content.document.fileDisplayName}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Commented regarding TCCP-1095 -->
                            <!-- <div class="col-12 mt-30" id="showMoreContentBlock">
                                    <a (click)="onShowLessClick();" class="show-more-text" *ngIf="showMoreText">SHOW LESS</a>
                                </div> -->
                        </div>
                    </span>
                    <!-- Commented regarding TCCP-1095 -->
                    <!-- <span *ngIf="windowWidth < 1024 && flowData.informationOrQuestion && contentWithoutTag.length >=50" class="informationOrquestion mt-30">
                            <div class="col-12 mt-3" id="showMoreContentBlock">
                                <a (click)="onShowMoreClick();" class="show-more-text" *ngIf="!showMoreText">SHOW MORE</a>
                            </div>
                        </span> -->
                    <!-- Mobile devices block ends  -->

                </div>

                <div class="col-1 p-0 arrows" *ngIf="!isPreview && this.storageService.getFeatureType() !== 'internal'">
                    <!-- <a (click)="getFlow(flowData.targetId.toString(),'next')" class="navigation-arrows next-arrow" [ngStyle]="{'visibility': (flowData.targetId || flowData.targetId === undefined) && (flowData.controls && flowData.controls.length === 0) ? 'visible':'hidden'}">
                        <img alt="Next" class="icon" [src]="nextArrowURL">
                        <div [hidden]="windowWidth > 1023" class="navigation-arrow-text next-text" (click)="getFlow(flowData.targetId.toString(),'next')"
                            [ngStyle]="{'visibility': (flowData.targetId || flowData.targetId === undefined) && (flowData.controls && flowData.controls.length === 0) ? 'visible':'hidden'}">Next
                        </div>
                    </a>
                    <div [hidden]="windowWidth < 1024" class="navigation-arrow-text next-text" (click)="getFlow(flowData.targetId.toString(),'next')"
                        [ngStyle]="{'visibility': (flowData.targetId || flowData.targetId === undefined) && (flowData.controls && flowData.controls.length === 0) ? 'visible':'hidden'}">Next
                    </div> -->
                    <span class="app-feedback-block" *ngIf="windowWidth < 1200 && showFeedback">
                        <app-feedback></app-feedback>
                    </span>
                </div>
            </div>

            <!-- Mobile devices badge, images, controls & tile block starts  -->
            <div class="row" *ngIf="windowWidth < 768">
                <div class="col-12">
                    <div class="badge-block badge-mobile mt-5" style="display: inline-flex;" *ngIf="(flowData.badges && flowData.badges.length > 0)">
                        <app-badge *ngIf="flowData.badges" [badges]="flowData.badges" [splitScreen]="flowData.hasContentSpliter">
                        </app-badge>
                    </div>

                    <div class="container-tile-block" [ngClass]="{'responsive-container-tile-block':windowWidth < 1024}" *ngIf="(flowData.controls && flowData.controls.length > 0) || flowData.phoneCompatibilty">
                        <div *ngFor="let control of flowData.controls; let k=index;" class="tile-block">
                            <button *ngIf="control && control.controlType === 'button' && control?.controlName.toLowerCase() !== 'home'" class="btn control-block"
                                (click)="getFlow(control.targetId)" type="button">{{control?.controlName}}</button>
                            <button *ngIf="control && control.controlType === 'button' && control?.controlName.toLowerCase() === 'home'" class="btn control-block"
                                (click)="getFlow(control.targetId,'done')" type="button">{{control?.controlName}}</button>
                            <span *ngIf="control && control.controlType.toLowerCase() === 'tile'" (click)="getFlow(control.targetId)">
                                <app-tile [control]="control">
                                </app-tile>
                            </span>
                        </div>
                        <div class="tile-block">
                            <button *ngIf="(flowData.phoneCompatibilty && flowData.isControlAsButton)" (click)="getCompatible(flowData.phoneCompatibilty.linkUrl)"
                                class="btn control-block" type="button">{{flowData.phoneCompatibilty.displayName}}</button>
                            <div *ngIf="flowData.phoneCompatibilty && !flowData.isControlAsButton" (click)="getCompatible(flowData.phoneCompatibilty.linkUrl)">
                                <app-tile [compatible]="flowData.phoneCompatibilty">
                                </app-tile>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Mobile devices block ends  -->

            <div class="row col-12 m-0 p-0 flow flow-icon-block" *ngIf="flowData">
                <div class="col-12 d-flex p-0">

                    <!-- Review comments -->
                    <div *ngIf="enableReview" class="float-right ml-auto d-flex review-comments-block">
                        <app-review-comments [reviewCommentInfo]="reviewCommentsInfo"></app-review-comments>
                    </div>
                </div>
            </div>

            <!-- Last step implementation starts -->
            <div class="row mt-5 p-0">
                <div class="col-1 p-0 ">
                </div>
                <div class="col-10 p-0">
                    <div *ngIf="flowData.isLastStep" class="last-step text-center col-12 mb-5">
                        <div class="issue information-text" *ngIf="!issueNotResolved"> Was this information helpful?
                        </div>
                        <div *ngIf="issueNotResolved && flowData.isLastStep">
                            <div *ngIf="appName=='toyota'">
                                <p class="message-text">{{ "Label.issue_unresolved_message_toyota" | translate}} </p>
                                <p class="message-text">{{ "Label.toyota_ex_center" | translate}} </p>
                                <p class="time-info"> Call
                                    <span class="contact-no">{{ "Label.toyota_contact_number" | translate}} </span>
                                </p>
                                <p class="time-info">{{ "Label.toyota_m-f_time" | translate}} </p>
                                <p class="time-info"> {{ "Label.toyota_sat_time" | translate}} </p>
                            </div>
                            <div *ngIf="appName=='lexus'">
                                <p class="message-text">{{ "Label.issue_unresolved_message_lexus" | translate}} </p>
                                <p class="message-text"> {{ "Label.lexus_ex_center" | translate}}</p>
                                <p class="time-info"> {{ "Label.lexus_contact_number" | translate}} </p>
                                <p class="time-info"> {{ "Label.lexus_m-f_time" | translate}}</p>
                                <p class="time-info"> {{ "Label.lexus_sat_time" | translate}}</p>
                            </div>
                        </div>
                        <div *ngIf="!issueNotResolved" class="mt-3 ">
                            <div class="issueNotResolved">
                                <button [disabled]="previewFromPublish" type="button" class="yes-button step-btn control-block" (click)="isPreview ? '' : yesButtonClicked();">
                                    Yes
                                </button>
                            </div>
                            <div class="issueNotResolved">
                                <button [disabled]="previewFromPublish" type="button" class="no-button step-btn control-block" (click)="isPreview ? '' : noButtonClicked();">
                                    No
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-1 p-0">
                </div>
            </div>
            <!-- Last step implementation ends -->

        </div>

    </div>
</div>

<div class="row col-12 m-0 p-0 flow flow-icon-block" *ngIf="flowData">
    <div class="col-12 d-flex p-0">

        <!-- Troubleshooting Steps -->
        <div class="troubleshooting-block" *ngIf="!previewFlow && flowData.troubleshoot && flowData.troubleshoot !== undefined && flowData.troubleshoot.troubleshootingSteps">
            <button matTooltip="Click Here For The Troubleshooting Steps" (click)="openTroubleshootingPopup(flowData.troubleshoot);"
                color="warn" class="review-comment-icon troubleshooting-btn" mat-fab aria-label="Example icon button with a heart icon">
                <mat-icon style="font-size: 35px;margin-right: 10px;margin-top: -11px;">construction</mat-icon>
            </button>
            <span *ngIf="windowWidth>=1200" class="d-block troubleshooting-link mt-2 mt-4">Troubleshooting Steps</span>
        </div>

        <!-- Feedback Control -->
        <!-- TCCP-1062 : commented the feedback control -->
        <div class="col-md-12 col-xl-12 col-sm-12 col-lg-12" *ngIf="showFeedback && !isPreview">
            <app-feedback></app-feedback>
        </div>
        <div class="col-md-12 col-xl-12 col-sm-12 col-lg-12" *ngIf="!previewFlow && flowData.faqs && flowData.faqs !== undefined && flowData.faqs.faqs">
            <app-faq [faqData]="flowData.faqs"></app-faq>
        </div>
    </div>
</div>

<div *ngIf="previewFlow">
    <app-dashboard [feature]="vehicleFeatures"></app-dashboard>
</div>
<!-- New next Back button implementation  -->
<div class="back-next-block d-flex" [ngClass]="{'back-next-admin-preview':previewFromPublish}" *ngIf="(!isPreview && windowWidth>1024 && flowData)">
    <app-progress-bar [hidden]="!showProgressBar" *ngIf="progressBarInfo && progressBarInfo.show && flowData && flowData.controls && flowData.controls.length === 0"
        [progressBarInfo]="progressBarInfo"></app-progress-bar>
    <div class="back-next-container d-flex">
        <div [ngStyle]="{'visibility':isPreview ? 'hidden':'visible'}" *ngIf="flowData.issueId">
            <button type="button" class="flow-navigation-btn flow-nav-back-btn" (click)="getFlow('','back')" [ngStyle]="{'visibility':isPreview ? 'hidden':'visible'}"
                *ngIf="flowData.issueId">
                Back
            </button>
        </div>
        <div *ngIf="!isPreview" class="flow-nav-next-block" [hidden]="progressBarInfo && progressBarInfo.show && progressBarInfo.percentage === 100">
            <button type="button" class="flow-navigation-btn flow-nav-next-btn" (click)="getFlow(flowData.targetId.toString(),'next')"
                [ngStyle]="{'visibility': (flowData.targetId || flowData.targetId === undefined) && (flowData.controls && flowData.controls.length === 0) ? 'visible':'hidden'}">
                Next</button>
        </div>
        <div *ngIf="!isPreview && progressBarInfo && progressBarInfo.show && progressBarInfo.percentage === 100" class="flow-nav-next-block">
            <button type="button" class="flow-navigation-btn flow-nav-next-btn flow-completed-btn" (click)="goToDashBoard();" #actionInfoTooltip="matTooltip"
                matTooltip="Return to Support Topics" matTooltipShowDelay="100" [matTooltipClass]="{'tooltip-completed-toyota':appName === 'toyota','tooltip-completed-lexus':appName === 'lexus'}">
                <i class="fa fa-check-circle-o pr-2" style="font-size:16px;" aria-hidden="true"></i>Completed</button>
        </div>
    </div>
</div>

<div class="back-next-block d-flex b-n-responsive" *ngIf="(windowWidth<=1024 && flowData)">
    <app-progress-bar [hidden]="!showProgressBar" *ngIf="progressBarInfo && progressBarInfo.show && flowData && flowData.controls && flowData.controls.length === 0"
        [progressBarInfo]="progressBarInfo"></app-progress-bar>
    <button mat-icon-button color="primary" [ngStyle]="{'visibility':isPreview ? 'hidden':'visible'}" *ngIf="flowData.issueId"
        type="button" class="flow-navigation-btn flow-nav-back-btn" (click)="getFlow('','back')">
        <mat-icon class="flow-nav-arrow" *ngIf="flowData.issueId">arrow_back_ios</mat-icon>Back
    </button>
    <button mat-icon-button color="primary" *ngIf="!isPreview" class="flow-nav-next-block" [hidden]="progressBarInfo && progressBarInfo.show && progressBarInfo.percentage === 100"
        type="button" class="flow-navigation-btn flow-nav-next-btn" (click)="getFlow(flowData.targetId.toString(),'next')" [ngStyle]="{'visibility': (flowData.targetId || flowData.targetId === undefined) && (flowData.controls && flowData.controls.length === 0) ? 'visible':'hidden'}">
        Next
        <mat-icon class="flow-nav-arrow" *ngIf="flowData.issueId">arrow_forward_ios</mat-icon>
    </button>
    <button #actionInfoooltip="matTooltip" mat-icon-button color="primary" matTooltip="Return to Support Topics" matTooltipPosition="below"
        matTooltipShowDelay="100" (click)="goToDashBoard();" *ngIf="!isPreview && progressBarInfo && progressBarInfo.show && progressBarInfo.percentage === 100"
        class="flow-navigation-btn flow-nav-next-btn flow-completed-btn" type="button" [matTooltipClass]="{'tooltip-completed-toyota':appName === 'toyota','tooltip-completed-lexus':appName === 'lexus'}">
        <i class="fa fa-check-circle-o pr-2" aria-hidden="true"></i>Completed
    </button>
</div>